// Cal Poly San Luis Obispo's undergraduate majors (#2652, founder 2026-09-30:
// "majors offered by the college in the public page"). Read on 2026-10-01
// from Cal Poly's official 2026-2028 Academic Catalog, Programs page
// (catalog.calpoly.edu/programs/), "Bachelor Degrees" list: every BS, BA,
// BFA, BArch and BLA. Each program sits in the college whose catalog path
// holds it (the college names are the catalog's own; "&" spelled "and").
// Six programs say "Offered at: Solano Campus" on their catalog page (the
// former Cal Maritime campus in Vallejo); they keep a note saying so, and the
// two Mechanical Engineering entries keep the catalog's campus labels.
// Flags quote Cal Poly's first-year Selection Criteria page (the college
// file's `selection` source): the Art and Design portfolio and the Music
// supplementary application. Every Cal Poly major is impacted; the college
// file's programs block says so. The KB's list was the starting point; the
// catalog wins.
const majors = {
    "slug": "california-polytechnic-state-university-san-luis-obispo",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree in Cal Poly's official 2026-2028 Academic Catalog, grouped by the college that offers it, with the degree it leads to. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agriculture, Food and Environmental Sciences",
            "source": {
                "label": "Cal Poly 2026-2028 Academic Catalog, Programs",
                "url": "https://catalog.calpoly.edu/programs/"
            },
            "majors": [
                {
                    "name": "Agricultural Business",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Communication",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Science",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Systems Management",
                    "degree": "BS"
                },
                {
                    "name": "Animal Science",
                    "degree": "BS"
                },
                {
                    "name": "BioResource and Agricultural Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Dairy Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Earth and Soil Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Management and Protection",
                    "degree": "BS"
                },
                {
                    "name": "Experience and Event Management",
                    "degree": "BS"
                },
                {
                    "name": "Food Science",
                    "degree": "BS"
                },
                {
                    "name": "Forest and Fire Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Marine Transportation",
                    "degree": "BS",
                    "note": "Offered at the Solano campus."
                },
                {
                    "name": "Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Plant Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Wine and Viticulture",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Architecture and Environmental Design",
            "source": {
                "label": "Cal Poly 2026-2028 Academic Catalog, Programs",
                "url": "https://catalog.calpoly.edu/programs/"
            },
            "majors": [
                {
                    "name": "Architectural Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Architecture",
                    "degree": "BArch"
                },
                {
                    "name": "City and Regional Planning",
                    "degree": "BS"
                },
                {
                    "name": "Construction Management",
                    "degree": "BS"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                }
            ]
        },
        {
            "name": "Orfalea College of Business",
            "source": {
                "label": "Cal Poly 2026-2028 Academic Catalog, Programs",
                "url": "https://catalog.calpoly.edu/programs/"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Technology and Packaging",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Cal Poly 2026-2028 Academic Catalog, Programs",
                "url": "https://catalog.calpoly.edu/programs/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Facilities Engineering Technology",
                    "degree": "BS",
                    "note": "Offered at the Solano campus."
                },
                {
                    "name": "General Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Manufacturing Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Marine Engineering Technology",
                    "degree": "BS",
                    "note": "Offered at the Solano campus."
                },
                {
                    "name": "Materials Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering (San Luis Obispo Campus)",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering (Solano Campus)",
                    "degree": "BS"
                },
                {
                    "name": "Software Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Liberal Arts",
            "source": {
                "label": "Cal Poly 2026-2028 Academic Catalog, Programs",
                "url": "https://catalog.calpoly.edu/programs/"
            },
            "majors": [
                {
                    "name": "Anthropology and Geography",
                    "degree": "BS"
                },
                {
                    "name": "Art and Design",
                    "degree": "BFA",
                    "flag": "Applicants must submit a portfolio by January 31.",
                    "flagSource": "selection"
                },
                {
                    "name": "Child Development",
                    "degree": "BS"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Ethnic Studies",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Graphic Communication",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "International Strategy and Security",
                    "degree": "BA",
                    "note": "Offered at the Solano campus."
                },
                {
                    "name": "Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA",
                    "flag": "Applicants must complete a supplementary application by January 31.",
                    "flagSource": "selection"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Bailey College of Science and Mathematics",
            "source": {
                "label": "Cal Poly 2026-2028 Academic Catalog, Programs",
                "url": "https://catalog.calpoly.edu/programs/"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Liberal Studies",
                    "degree": "BS"
                },
                {
                    "name": "Marine Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Oceanography",
                    "degree": "BS",
                    "note": "Offered at the Solano campus."
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Interdisciplinary Degree Programs",
            "source": {
                "label": "Cal Poly 2026-2028 Academic Catalog, Programs",
                "url": "https://catalog.calpoly.edu/programs/"
            },
            "majors": [
                {
                    "name": "Liberal Arts and Engineering Studies",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
